import { Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { GuestGuard } from "./guards/guest.guard";
import { HomeGuard } from "./guards/home.guard";
import { SecureLayoutComponent } from "./layouts/secure-layout/secure-layout.component";
import { PublicLayoutComponent } from "./layouts/public-layout/public-layout.component";

export const publicRoutes: Routes = [
  {
    path: "docs/v1",
    loadComponent: () =>
      import("./pages/docs-v1/docs-v1.component").then(
        (m) => m.DocsV1Component,
      ),
  },
  {
    path: "docs/changelog",
    loadComponent: () =>
      import("./pages/docs-changelog/docs-changelog.component").then(
        (m) => m.DocsChangelogComponent,
      ),
  },

  {
    path: "disclaimer",
    loadComponent: () =>
      import("./pages/disclaimer/disclaimer").then(
        (m) => m.DisclaimerComponent,
      ),
  },
];

export const publicRoutesUser: Routes = [
  {
    path: "dashboard/docs/v1",
    loadComponent: () =>
      import("./pages/docs-v1/docs-v1.component").then(
        (m) => m.DocsV1Component,
      ),
  },
  {
    path: "dashboard/docs/changelog",
    loadComponent: () =>
      import("./pages/docs-changelog/docs-changelog.component").then(
        (m) => m.DocsChangelogComponent,
      ),
  },
];

export const routes: Routes = [
  {
    path: "",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        canActivate: [HomeGuard],
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent,
          ),
      },
      ...publicRoutes,
      {
        path: "login",
        canActivate: [GuestGuard],
        loadComponent: () =>
          import("./pages/login/login.component").then((m) => m.LoginComponent),
      },
      {
        path: "sign-up",
        canActivate: [GuestGuard],
        loadComponent: () =>
          import("./pages/sign-up/sign-up").then((m) => m.SignUpComponent),
      },
      {
        path: "forgot-password",
        canActivate: [GuestGuard],
        loadComponent: () =>
          import("./pages/forgot-password/forgot-password").then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: "logout",
        loadComponent: () =>
          import("./pages/logout/logout.component").then(
            (m) => m.LogoutComponent,
          ),
      },
    ],
  },
  {
    path: "",
    component: SecureLayoutComponent,
    children: [
      {
        path: "dashboard",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: "dashboard/uploads/:fileId",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/dashboard-detail/dashboard-detail.component").then(
            (m) => m.DashboardDetailComponent,
          ),
      },
      {
        path: "settings",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/settings/settings.component").then(
            (m) => m.SettingsComponent,
          ),
      },
      {
        path: "admin",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/administrator/administrator.component").then(
            (m) => m.AdministratorComponent,
          ),
      },
      {
        path: "music",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/music/music.component").then((m) => m.MusicComponent),
      },
      {
        path: "history",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("./pages/history/history.component").then(
            (m) => m.HistoryComponent,
          ),
      },
      {
        path: "youtube",
        loadComponent: () =>
          import("./pages/youtube-redirect/youtube-redirect.component").then(
            (m) => m.YoutubeRedirectComponent,
          ),
      },
      ...publicRoutesUser,
    ],
  },
  { path: "**", redirectTo: "/", pathMatch: "full" },
];
